import {fromJS} from "immutable";
import {replaceNaNWithZero} from "../../common/shared";
import * as actionTypes from "../constants";

export const initialState = fromJS({
    admin: {
        lazyLoadFlags: {
            planSettingsLoaded: false
        },
        defaultInflation: {
            isSystemWide: true,
            systemWideInflation: 0,
            discountRate: 0,
            income: 0,
            expense: 0,
            contributions: 0,
            goal: 0
        },
        planSimulation: {
            futureValue: false,
            logarithmic: false,
            proRateFirstYear: false,
            numberOfSimulations: 1000
        },
        clientKeyDates: {
            retirementAge: 65,
            lifeExpectancy: 95
        },
        trackingThresholds: {
            goalBased: {
                from: 0,
                to: 1
            },
            ssrPlan: {
                from: 0,
                to: 1
            }
        },
        defaultAllocation: {
            id: 1,
            name: "My Default Allocation"
        }
    },
    advisor: {
        lazyLoadFlags: {
            planSettingsLoaded: false
        },
        defaultInflation: {
            isSystemWide: true,
            systemWideInflation: 0,
            discountRate: 0,
            income: 0,
            expense: 0,
            contributions: 0,
            goal: 0
        },
        planSimulation: {
            futureValue: false,
            logarithmic: false,
            proRateFirstYear: false,
            numberOfSimulations: 1000
        },
        clientKeyDates: {
            retirementAge: 65,
            lifeExpectancy: 95
        },
        trackingThresholds: {
            goalBased: {
                from: 0,
                to: 1
            },
            ssrPlan: {
                from: 0,
                to: 1
            }
        },
        defaultAllocation: {
            id: 1,
            name: "My Default Allocation"
        }
    },
    showAddAllocationModel : false,
    showAddFeeModel : false
});

export default function reducer(state = initialState, action) {
    switch(action.type) {
        case actionTypes.UPDATE_ADMIN_DEFAULT_INFLATION:
            return state
                .setIn(["admin", "defaultInflation", "isSystemWide"], action.data.isSystemWide)
                .setIn(["admin", "defaultInflation", "systemWideInflation"], replaceNaNWithZero(action.data.systemWideInflation))
                .setIn(["admin", "defaultInflation", "discountRate"], replaceNaNWithZero(action.data.discountRate))
                .setIn(["admin", "defaultInflation", "income"], replaceNaNWithZero(action.data.income))
                .setIn(["admin", "defaultInflation", "expense"], replaceNaNWithZero(action.data.expense))
                .setIn(["admin", "defaultInflation", "contributions"], replaceNaNWithZero(action.data.contributions))
                .setIn(["admin", "defaultInflation", "goal"], replaceNaNWithZero(action.data.goal));
        case actionTypes.UPDATE_ADMIN_PLAN_SIMULATION:
            return state
                .setIn(["admin", "planSimulation", "futureValue"], action.data.futureValue)
                .setIn(["admin", "planSimulation", "logarithmic"], action.data.logarithmic)
                .setIn(["admin", "planSimulation", "proRateFirstYear"], action.data.proRateFirstYear)
                .setIn(["admin", "planSimulation", "numberOfSimulations"], action.data.numberOfSimulations);
        case actionTypes.UPDATE_ADMIN_CLIENT_KEY_DATES:
            return state
                .setIn(["admin", "clientKeyDates", "retirementAge"], replaceNaNWithZero(action.data.retirementAge))
                .setIn(["admin", "clientKeyDates", "lifeExpectancy"], replaceNaNWithZero(action.data.lifeExpectancy));
        case actionTypes.UPDATE_ADMIN_TRACKING_THRESHOLDS:
            return state
                .setIn(["admin", "trackingThresholds", "goalBased", "from"], action.data.goalBased.from)
                .setIn(["admin", "trackingThresholds", "goalBased", "to"], action.data.goalBased.to)
                .setIn(["admin", "trackingThresholds", "ssrPlan", "from"], action.data.ssrPlan.from)
                .setIn(["admin", "trackingThresholds", "ssrPlan", "to"], action.data.ssrPlan.to);
        case actionTypes.SET_ADMIN_DEFAULT_PLAN_SETTINGS:
            return state
                .setIn(["admin", "lazyLoadFlags", "planSettingsLoaded"], true)
                .setIn(["admin", "defaultInflation", "isSystemWide"], action.data.inflationAndDiscount.isSystemWideInflation)
                .setIn(["admin", "defaultInflation", "systemWideInflation"], action.data.inflationAndDiscount.systemWideInflation / 100)
                .setIn(["admin", "defaultInflation", "discountRate"], action.data.inflationAndDiscount.discountRate / 100)
                .setIn(["admin", "defaultInflation", "income"], action.data.inflationAndDiscount.incomeInflation / 100)
                .setIn(["admin", "defaultInflation", "expense"], action.data.inflationAndDiscount.expenseInflation / 100)
                .setIn(["admin", "defaultInflation", "contributions"], action.data.inflationAndDiscount.contributionsWithdrawalInflation / 100)
                .setIn(["admin", "defaultInflation", "goal"], action.data.inflationAndDiscount.goalInflation / 100)
                .setIn(["admin", "planSimulation", "futureValue"], action.data.planSimulation.isFutureValue)
                .setIn(["admin", "planSimulation", "logarithmic"], action.data.planSimulation.isLogarithimic)
                .setIn(["admin", "planSimulation", "proRateFirstYear"], action.data.planSimulation.isProrateFirstYear)
                .setIn(["admin", "planSimulation", "numberOfSimulations"], action.data.planSimulation.numberOfSimulation)
                .setIn(["admin", "clientKeyDates", "retirementAge"], action.data.clientKeyDates.retirementAge)
                .setIn(["admin", "clientKeyDates", "lifeExpectancy"], action.data.clientKeyDates.lifeExpectancyAge)
                .setIn(["admin", "trackingThresholds", "goalBased", "from"], action.data.trackingThresholds.goalBasedPlan.min / 100)
                .setIn(["admin", "trackingThresholds", "goalBased", "to"], action.data.trackingThresholds.goalBasedPlan.max / 100)
                .setIn(["admin", "trackingThresholds", "ssrPlan", "from"], action.data.trackingThresholds.safeSavingsRatePlan.min / 100)
                .setIn(["admin", "trackingThresholds", "ssrPlan", "to"], action.data.trackingThresholds.safeSavingsRatePlan.max / 100);
        case actionTypes.UPDATE_ADVISOR_DEFAULT_INFLATION:
            return state
                .setIn(["advisor", "defaultInflation", "isSystemWide"], action.data.isSystemWide)
                .setIn(["advisor", "defaultInflation", "systemWideInflation"], replaceNaNWithZero(action.data.systemWideInflation))
                .setIn(["advisor", "defaultInflation", "discountRate"], replaceNaNWithZero(action.data.discountRate))
                .setIn(["advisor", "defaultInflation", "income"], replaceNaNWithZero(action.data.income))
                .setIn(["advisor", "defaultInflation", "expense"], replaceNaNWithZero(action.data.expense))
                .setIn(["advisor", "defaultInflation", "contributions"], replaceNaNWithZero(action.data.contributions))
                .setIn(["advisor", "defaultInflation", "goal"], replaceNaNWithZero(action.data.goal));
        case actionTypes.UPDATE_ADVISOR_PLAN_SIMULATION:
            return state
                .setIn(["advisor", "planSimulation", "futureValue"], action.data.futureValue)
                .setIn(["advisor", "planSimulation", "logarithmic"], action.data.logarithmic)
                .setIn(["advisor", "planSimulation", "proRateFirstYear"], action.data.proRateFirstYear)
                .setIn(["advisor", "planSimulation", "numberOfSimulations"], action.data.numberOfSimulations);
        case actionTypes.UPDATE_ADVISOR_CLIENT_KEY_DATES:
            return state
                .setIn(["advisor", "clientKeyDates", "retirementAge"], action.data.retirementAge)
                .setIn(["advisor", "clientKeyDates", "lifeExpectancy"], action.data.lifeExpectancy);
        case actionTypes.UPDATE_ADVISOR_TRACKING_THRESHOLDS:
            return state
                .setIn(["advisor", "trackingThresholds", "goalBased", "from"], action.data.goalBased.from)
                .setIn(["advisor", "trackingThresholds", "goalBased", "to"], action.data.goalBased.to)
                .setIn(["advisor", "trackingThresholds", "ssrPlan", "from"], action.data.ssrPlan.from)
                .setIn(["advisor", "trackingThresholds", "ssrPlan", "to"], action.data.ssrPlan.to);
        case actionTypes.SET_ADVISOR_DEFAULT_PLAN_SETTINGS:
            return state
                .setIn(["advisor", "lazyLoadFlags", "planSettingsLoaded"], true)
                .setIn(["advisor", "defaultInflation", "isSystemWide"], action.data.inflationAndDiscount.isSystemWideInflation)
                .setIn(["advisor", "defaultInflation", "systemWideInflation"], action.data.inflationAndDiscount.systemWideInflation / 100)
                .setIn(["advisor", "defaultInflation", "discountRate"], action.data.inflationAndDiscount.discountRate / 100)
                .setIn(["advisor", "defaultInflation", "income"], action.data.inflationAndDiscount.incomeInflation / 100)
                .setIn(["advisor", "defaultInflation", "expense"], action.data.inflationAndDiscount.expenseInflation / 100)
                .setIn(["advisor", "defaultInflation", "contributions"], action.data.inflationAndDiscount.contributionsWithdrawalInflation / 100)
                .setIn(["advisor", "defaultInflation", "goal"], action.data.inflationAndDiscount.goalInflation / 100)
                .setIn(["advisor", "planSimulation", "futureValue"], action.data.planSimulation.isFutureValue)
                .setIn(["advisor", "planSimulation", "logarithmic"], action.data.planSimulation.isLogarithimic)
                .setIn(["advisor", "planSimulation", "proRateFirstYear"], action.data.planSimulation.isProrateFirstYear)
                .setIn(["advisor", "planSimulation", "numberOfSimulations"], action.data.planSimulation.numberOfSimulation)
                .setIn(["advisor", "clientKeyDates", "retirementAge"], action.data.clientKeyDates.retirementAge)
                .setIn(["advisor", "clientKeyDates", "lifeExpectancy"], action.data.clientKeyDates.lifeExpectancyAge)
                .setIn(["advisor", "trackingThresholds", "goalBased", "from"], action.data.trackingThresholds.goalBasedPlan.min / 100)
                .setIn(["advisor", "trackingThresholds", "goalBased", "to"], action.data.trackingThresholds.goalBasedPlan.max / 100)
                .setIn(["advisor", "trackingThresholds", "ssrPlan", "from"], action.data.trackingThresholds.safeSavingsRatePlan.min / 100)
                .setIn(["advisor", "trackingThresholds", "ssrPlan", "to"], action.data.trackingThresholds.safeSavingsRatePlan.max / 100);
        case actionTypes.SHOW_ADD_ALLOCATION_MODEL:
            return state.setIn(["showAddAllocationModel"],action.showAddAllocationModel)
        case actionTypes.SHOW_ADD_FEE_MODEL:
            return state.setIn(["showAddFeeModel"],action.showAddFeeModel)
    }
    return state;
}